const McuReport = () => {
    return (<h1>MCU Report..</h1>);
};

export default McuReport;